export const helpConstants = {
    HELP_REQUEST: 'HELP_REQUEST',
    HELP_GET_SUCCESS: 'HELP_GET_SUCCESS',
    HELP_FAILURE: 'HELP_FAILURE', 
    DELETE_HELP_SUCCESS : 'DELETE_HELP_SUCCESS',
    HELP_FORM_REQUEST: 'HELP_FORM_REQUEST',
    UPDATE_HELP_SUCCESS: 'UPDATE_HELP_SUCCESS',
    HELP_SAVE_FORM_FAILURE: 'HELP_SAVE_FORM_FAILURE',
    EXPORT_HELP_REQUEST: 'EXPORT_HELP_REQUEST',
    EXPORT_HELP_SUCCESS: 'EXPORT_HELP_SUCCESS',
    EXPORT_HELP_FAILURE: 'EXPORT_HELP_FAILURE',
}